import { Route } from '@angular/router';
import { AuthGuard } from 'app/configuration/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/configuration/auth/guards/noAuth.guard';
import { FirstAccessAuthGuard } from 'app/configuration/auth/guards/firstAccess.guard';
import { changeRoleAuthGuard } from 'app/configuration/auth/guards/changeRoleAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
/* Querido programador: 
  /# Cuando escribí este codigo, sólo Dios y yo 
  /# sabíamos cómo funcionaba. 
  /# Ahora ¡sólo Dios lo sabe!
  /# 
  /# Así que si estas tratando de 'optimizar' este archivo
  /# y fracasas (que seguramente sucederá),
  /# por favor, incremente el siguiente contador 
  /# como una advertencia 
  /# para la siguiente persona que lo intente:
  /# 
  /# $total_horas_perdidas_aquí =  342 
  /# mlqz*/
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  // Redirect empty path to '/dashboard/home'
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  // Redirect signed in user to the '/dashboard/home'
  //
  // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  {
    path: 'signed-in-redirect',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'unblock-user',
        loadChildren: () => import('app/modules/public/unblock-user/unblock-user.module').then(m => m.UnblockUserModule)
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('app/modules/public/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
      }, {
        path: 'login',
        loadChildren: () => import('app/modules/public/sign-in/sign-in.module').then(m => m.AuthSignInModule)
      }
    ]
  },
  { // First access 
    path: '',
    canActivate: [FirstAccessAuthGuard],
    canActivateChild: [FirstAccessAuthGuard],
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: 'first-access',
        loadChildren: () => import('app/modules/public/first-access/first-access.module').then(publicSession => publicSession.FirstAccessModule)
      }
    ]
  },
  { // asignacion de clave operativa
    path: '',
    canActivate: [changeRoleAuthGuard],
    canActivateChild: [changeRoleAuthGuard],
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: 'assign-key-oper',
        loadChildren: () => import('app/modules/public/assign-key-oper/assign-key-oper.module').then(publicSession => publicSession.AssignKeyOperModule)
      }
    ]
  },
  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/modules/public/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
      }
    ]
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'modern'
    },
    resolve: {
      initialData: InitialDataResolver
    },
    children: [
      // Dashboard
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            loadChildren: () => import('app/modules/site/dashboards/dashboard.module').then(m => m.DashboardModule)
          }
        ]
      },
      {
        path: 'informacion',
        children: [
          {
            path: 'financiera',
            loadChildren: () => import('app/modules/site/information/financial/financiera.module').then(i => i.FinancieraModule)
          }
        ]
      },
      // Nosotros
      {
        path: 'nosotros',
        children: [
          { // Horarios
            path: 'horarios',
            loadChildren: () => import('app/modules/site/us/schedules/schedules.module').then(m => m.HorariosModule)
          },
          { // Comisiones
            path: 'comisiones',
            loadChildren: () => import('app/modules/site/us/commissions/commissions.module').then(m => m.ComisionesModule)
          },
        ]
      },
      { // Operaciones
        path: 'operaciones',
        children: [
          { // fondos
            path: 'fondosInversion',
            loadChildren: () => import('app/modules/site/operations/investment-funds/investment-funds.module').then(o => o.FundsModule)
          },
          { // Mercado de capitales
            path: "retiro",
            loadChildren: () =>
              import("app/modules/site/operations/withdrawal/withdrawal.module").then(o => o.WithDrawalsModule),
          },
          { // Mercado de capitales nuevo
            path: "mercadoCapitales",
            loadChildren: () =>
              import("app/modules/site/operations/capitals-market/capitals-market.module").then(o => o.MarketModule)
          }
        ]
      },
      { // Consultas
        path: 'consulta',
        children: [
          { // 
            path: 'saldos',
            loadChildren: () => import('app/modules/site/consult/balances/balances.module').then(c => c.BalancesModule)
          },
          {
            path: 'documentos',
            loadChildren: () => import('app/modules/site/consult/documents/documents.module').then(c => c.DocumentsModule)
          },
          {
            path: 'informacion',
            loadChildren: () => import('app/modules/site/consult/estado-cuentas/estado-cuentas.module').then(m => m.EstadoCuentasModule)
          }
        ]
      },
      { // Configuracion
        path: 'configuracion',
        children: [
          { // 
            path: 'cambioContrasena',
            loadChildren: () => import('app/modules/site/config/change-password/change-password.module').then(cnfig => cnfig.ChangePsswrdModule)
          },
          {
            path: 'claveOperativa',
            loadChildren: () => import('app/modules/site/config/operative-key/operative-key.module').then(cnfig => cnfig.OperativeKeyModule)
          },
          {
            path: 'edoCuentaDigital',
            loadChildren: () => import('app/modules/site/config/paperless/paperless.module').then(cnfig => cnfig.PaperlessModule)
          },
          {
            path: 'actualizacionDatosContacto',
            loadChildren: () => import('app/modules/site/config/contact-information/contact-information.module').then(cnfig => cnfig.ContactInformationModule)
          }
        ]
      },
      { // Pages
        path: 'pages',
        children: [
          // Error
          {
            path: 'error',
            children: [
              {
                path: '404',
                loadChildren: () => import('app/modules/site/pages/error/error-404/error-404.module').then(m => m.Error404Module)
              }, {
                path: '500',
                loadChildren: () => import('app/modules/site/pages/error/error-500/error-500.module').then(m => m.Error500Module)
              }
            ]
          },
        ]
      },
      // 404 & Catch all
      {
        path: '404-not-found',
        pathMatch: 'full',
        loadChildren: () => import('app/modules/site/pages/error/error-404/error-404.module').then(m => m.Error404Module)
      }, {
        path: '**',
        redirectTo: '404-not-found'
      }
    ]
  }
];
